import React, { useState } from 'react';
import { Modal, Input } from 'antd';

/**
 * Confirmation + optional-reason capture for soft-deleting an order.
 *
 * The reason is kept in local state on purpose: a controlled TextArea bound to
 * page-level state re-renders the entire PACS/Orders page on every keystroke.
 * Parents should mount this conditionally ({visible && <DeleteOrderModal/>}) so
 * the reason resets on each open.
 */
const DeleteOrderModal = ({
  open,
  patientName,
  accessionNumber,
  loading,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  patientName?: string;
  accessionNumber?: string;
  loading?: boolean;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}) => {
  const [reason, setReason] = useState('');

  return (
    <Modal
      title="Delete Order"
      open={open}
      okText="Delete"
      okButtonProps={{ danger: true, loading }}
      onOk={() => onConfirm(reason.trim())}
      onCancel={onCancel}
    >
      <div style={{ marginBottom: 8 }}>
        Patient: <b>{patientName || '-'}</b>
        {accessionNumber ? ` • Acc: ${accessionNumber}` : ''}
      </div>
      <p style={{ marginBottom: 8 }}>
        This hides the order from the worklist and deactivates its study in the DICOM server
        (reversible via Restore).
      </p>
      <Input.TextArea
        rows={3}
        value={reason}
        placeholder="Reason for deletion (optional)"
        onChange={e => setReason(e.target.value)}
      />
    </Modal>
  );
};

export default DeleteOrderModal;
